import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import { ErrorAlert } from '../../utils/Alerts';
import { unauthHeaders } from '../../utils/API';
import Lk from './Lk';
import UserContext from '../../UserContext';

const LkContainer = () => {
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [user, setUser] = useState();

    const userContext = useContext(UserContext);
    const { currentMenuItem } = useContext(UserContext);

    const getUserProfile = () => {
        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_API}api/v1.0/profile`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsLoading(false);
                setUser(res.data[0]);
                userContext && userContext.setUser(res.data[0])
                sessionStorage.setItem('userId', res.data[0].id)
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    useEffect(() => {
        getUserProfile();
    }, [])

    const logout = () => {
        sessionStorage.clear();
        history.push(`${process.env.REACT_APP_WEBSITE_NAME}`);
    }

    return (
        <>
            {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
            <Lk
                logout={logout}
                user={user}
                currentMenuItem={currentMenuItem}
            />
        </>
    )
}

export default LkContainer;
